import FunctionHeader from "presentation/components/Header/FunctionHeader";
import ProjectForm from "presentation/components/Project/ProjectForm";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useParams } from "react-router-dom";

const ProjectFormPage = () => {
  const { id } = useParams();
  const { isLoading } = usePermissionCheck({ requiredFunction: "projects" });

  if (isLoading) {
    return <Spinner />;
  }

  const isEditing = !!id;

  const title = isEditing ? "Editar Projeto" : "Criar Projeto";
  return (
    <div>
      <FunctionHeader title={title} />
      <ProjectForm />
    </div>
  );
};

export default ProjectFormPage;
